import { Component } from '@angular/core';
import * as Chartist from 'chartist';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { DatePipe } from "@angular/common";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { default as _rollupMoment, Moment,} from 'moment';
import { FormControl } from '@angular/forms';
import {MatDatepicker} from '@angular/material/datepicker';
import { Dashboard } from '../../models/Dashboard';
import { environment } from 'environments/environment';

const moment = _rollupMoment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-kpi2-dashboard',
  templateUrl: './kpi2.component.html',
  styleUrls: ['./kpi2.component.css'],
  providers:[DatePipe,
    {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class Kpi2Component{

  date = new FormControl(moment());
  totalCartera:any=0;
  dataactual:any; 
  monedaElement : any = 1255;
  loading: boolean = false;
  disable: boolean = false;
  simbolo: any; 
  datarandom: any={
    '202411':
    {
      '1255':[{
        dia:"1",
        monto:2.5,
        operaciones:2,
        acum:0
      },{ 
        dia:"2",
        monto:1.5,
        operaciones:5 
      },{ 
        dia:"3",
        monto:0.5,
        operaciones:2 
      },{ 
        dia:"4",
        monto:0.6,
        operaciones:3 
      },{ 
        dia:"5",
        monto:0.4,
        operaciones:2 
      },{ 
        dia:"6",
        monto:1.8,
        operaciones:12 
      },{ 
        dia:"7",
        monto:1.9,
        operaciones:3 
      },{ 
        dia:"8",
        monto:1.2,
        operaciones:3 
      },{ 
        dia:"9",
        monto:1.6,
        operaciones:6 
      },{ 
        dia:"10",
        monto:2,
        operaciones:3 
      },{ 
        dia:"11",
        monto:1.9,
        operaciones:10 
      },{ 
        dia:"12",
        monto:0.8,
        operaciones:10 
      },{ 
        dia:"13",
        monto:1.6,
        operaciones:5 
      },{ 
        dia:"14",
        monto:0.1,
        operaciones:9 
      },{ 
        dia:"15",
        monto:1.8,
        operaciones:1 
      },{ 
        dia:"16",
        monto:1.0,
        operaciones:10 
      },{ 
        dia:"17",
        monto:1.6,
        operaciones:5 
      },{ 
        dia:"18",
        monto:1.7,
        operaciones:10 
      },{ 
        dia:"19",
        monto:0.3,
        operaciones:11 
      },{ 
        dia:"20",
        monto:0.5,
        operaciones:2 
      },{ 
        dia:"21",
        monto:1.9,
        operaciones:10 
      },{ 
        dia:"22",
        monto:2.5,
        operaciones:6 
      },{ 
        dia:"23",
        monto:2.4,
        operaciones:12 
      },{ 
        dia:"24",
        monto:0.6,
        operaciones:15 
      },{ 
        dia:"25",
        monto:0.3,
        operaciones:15 
      },{ 
        dia:"26",
        monto:0.4,
        operaciones:2 
      },{ 
        dia:"27",
        monto:1.3,
        operaciones:7 
      },{ 
        dia:"28",
        monto:0.9,
        operaciones:5 
      },{ 
        dia:"29",
        monto:1.6,
        operaciones:14 
      },{ 
        dia:"30",
        monto:2.4,
        operaciones:8 
      }],
      '1447': [{
        dia:"1",
        monto:1.5,
        operaciones:1
      },{ 
        dia:"2",
        monto:0.5,
        operaciones:8 
      },{ 
        dia:"3",
        monto:0.5,
        operaciones:2 
      },{ 
        dia:"4",
        monto:0.6,
        operaciones:3 
      },{ 
        dia:"5",
        monto:1.4,
        operaciones:9 
      },{ 
        dia:"6",
        monto:1.8,
        operaciones:12 
      },{ 
        dia:"7",
        monto:1.9,
        operaciones:3 
      },{ 
        dia:"8",
        monto:0.2,
        operaciones:13 
      },{ 
        dia:"9",
        monto:1.6,
        operaciones:6 
      },{ 
        dia:"10",
        monto:1.2,
        operaciones:13 
      },{ 
        dia:"11",
        monto:1.9,
        operaciones:10 
      },{ 
        dia:"12",
        monto:0.8,
        operaciones:10 
      },{ 
        dia:"13",
        monto:0.6,
        operaciones:4 
      },{ 
        dia:"14",
        monto:0.1,
        operaciones:9 
      },{ 
        dia:"15",
        monto:1.3,
        operaciones:2 
      },{ 
        dia:"16",
        monto:1.0,
        operaciones:10 
      },{ 
        dia:"17",
        monto:1.6,
        operaciones:5 
      },{ 
        dia:"18",
        monto:0.7,
        operaciones:14 
      },{ 
        dia:"19",
        monto:0.3,
        operaciones:11 
      },{ 
        dia:"20",
        monto:0.5,
        operaciones:2 
      },{ 
        dia:"21",
        monto:1.0,
        operaciones:8 
      },{ 
        dia:"22",
        monto:2.5,
        operaciones:6 
      },{ 
        dia:"23",
        monto:0.4,
        operaciones:7 
      },{ 
        dia:"24",
        monto:0.6,
        operaciones:15 
      },{ 
        dia:"25",
        monto:1.3,
        operaciones:5 
      },{ 
        dia:"26",
        monto:0.4,
        operaciones:2 
      },{ 
        dia:"27",
        monto:0.3,
        operaciones:4 
      },{ 
        dia:"28",
        monto:0.9,
        operaciones:5 
      },{ 
        dia:"29",
        monto:1.6,
        operaciones:14 
      },{ 
        dia:"30",
        monto:0.4,
        operaciones:14 
      },{ 
        dia:"31",
        monto:0.7,
        operaciones:2 
      }]
    }
    
    ,
    '202410':
    {
      '1447':[{
        dia:"1",
        monto:2.5,
        operaciones:2,
        acum:0
      },{ 
        dia:"2",
        monto:1.5,
        operaciones:5 
      },{ 
        dia:"3",
        monto:0.5,
        operaciones:2 
      },{ 
        dia:"4",
        monto:0.6,
        operaciones:3 
      },{ 
        dia:"5",
        monto:0.4,
        operaciones:2 
      },{ 
        dia:"6",
        monto:1.8,
        operaciones:12 
      },{ 
        dia:"7",
        monto:1.9,
        operaciones:3 
      },{ 
        dia:"8",
        monto:1.2,
        operaciones:3 
      },{ 
        dia:"9",
        monto:1.6,
        operaciones:6 
      },{ 
        dia:"10",
        monto:2,
        operaciones:3 
      },{ 
        dia:"11",
        monto:1.9,
        operaciones:10 
      },{ 
        dia:"12",
        monto:0.8,
        operaciones:10 
      },{ 
        dia:"13",
        monto:1.6,
        operaciones:5 
      },{ 
        dia:"14",
        monto:0.1,
        operaciones:9 
      },{ 
        dia:"15",
        monto:1.8,
        operaciones:1 
      },{ 
        dia:"16",
        monto:1.0,
        operaciones:10 
      },{ 
        dia:"17",
        monto:1.6,
        operaciones:5 
      },{ 
        dia:"18",
        monto:1.7,
        operaciones:10 
      },{ 
        dia:"19",
        monto:0.3,
        operaciones:11 
      },{ 
        dia:"20",
        monto:0.5,
        operaciones:2 
      },{ 
        dia:"21",
        monto:1.9,
        operaciones:10 
      },{ 
        dia:"22",
        monto:2.5,
        operaciones:6 
      },{ 
        dia:"23",
        monto:2.4,
        operaciones:12 
      },{ 
        dia:"24",
        monto:0.6,
        operaciones:15 
      },{ 
        dia:"25",
        monto:0.3,
        operaciones:15 
      },{ 
        dia:"26",
        monto:0.4,
        operaciones:2 
      },{ 
        dia:"27",
        monto:1.3,
        operaciones:7 
      },{ 
        dia:"28",
        monto:0.9,
        operaciones:5 
      },{ 
        dia:"29",
        monto:1.6,
        operaciones:14 
      },{ 
        dia:"30",
        monto:2.4,
        operaciones:8 
      }],
      '1255': [{
        dia:"1",
        monto:1.5,
        operaciones:1
      },{ 
        dia:"2",
        monto:0.5,
        operaciones:8 
      },{ 
        dia:"3",
        monto:0.5,
        operaciones:2 
      },{ 
        dia:"4",
        monto:0.6,
        operaciones:3 
      },{ 
        dia:"5",
        monto:1.4,
        operaciones:9 
      },{ 
        dia:"6",
        monto:1.8,
        operaciones:12 
      },{ 
        dia:"7",
        monto:1.9,
        operaciones:3 
      },{ 
        dia:"8",
        monto:0.2,
        operaciones:13 
      },{ 
        dia:"9",
        monto:1.6,
        operaciones:6 
      },{ 
        dia:"10",
        monto:1.2,
        operaciones:13 
      },{ 
        dia:"11",
        monto:1.9,
        operaciones:10 
      },{ 
        dia:"12",
        monto:0.8,
        operaciones:10 
      },{ 
        dia:"13",
        monto:0.6,
        operaciones:4 
      },{ 
        dia:"14",
        monto:0.1,
        operaciones:9 
      },{ 
        dia:"15",
        monto:1.3,
        operaciones:2 
      },{ 
        dia:"16",
        monto:1.0,
        operaciones:10 
      },{ 
        dia:"17",
        monto:1.6,
        operaciones:5 
      },{ 
        dia:"18",
        monto:0.7,
        operaciones:14 
      },{ 
        dia:"19",
        monto:0.3,
        operaciones:11 
      },{ 
        dia:"20",
        monto:0.5,
        operaciones:2 
      },{ 
        dia:"21",
        monto:1.0,
        operaciones:8 
      },{ 
        dia:"22",
        monto:2.5,
        operaciones:6 
      },{ 
        dia:"23",
        monto:0.4,
        operaciones:7 
      },{ 
        dia:"24",
        monto:0.6,
        operaciones:15 
      },{ 
        dia:"25",
        monto:1.3,
        operaciones:5 
      },{ 
        dia:"26",
        monto:0.4,
        operaciones:2 
      },{ 
        dia:"27",
        monto:0.3,
        operaciones:4 
      },{ 
        dia:"28",
        monto:0.9,
        operaciones:5 
      },{ 
        dia:"29",
        monto:1.6,
        operaciones:14 
      },{ 
        dia:"30",
        monto:0.4,
        operaciones:14 
      },{ 
        dia:"31",
        monto:0.7,
        operaciones:2 
      }]
    }
  }
    
  ;
  constructor(private dashboardService:DashboardService,private datePipe: DatePipe) { }
  
  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);
    //this.obtenerDashboardFecha();
  }
  startAnimationForLineChart(chart){
      let seq: any, delays: any, durations: any;
      seq = 0;
      delays = 80;
      durations = 500;

      chart.on('draw', function(data) {
        if(data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if(data.type === 'point') {
              seq++;
              data.element.animate({
                opacity: {
                  begin: seq * delays,
                  dur: durations,
                  from: 0,
                  to: 1,
                  easing: 'ease'
                }
              });
          }
      });

      seq = 0;
  };
  startAnimationForBarChart(chart){
      let seq2: any, delays2: any, durations2: any;

      seq2 = 0;
      delays2 = 80;
      durations2 = 500;
      chart.on('draw', function(data) {
        if(data.type === 'bar'){
            seq2++;
            data.element.animate({
              opacity: {
                begin: seq2 * delays2,
                dur: durations2,
                from: 0,
                to: 1,
                easing: 'ease'
              }
            });
        }
      });

      seq2 = 0;
  };
  ngOnInit() {
       
      this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);

       

  }
  sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
  async getrandom(periodo,monedaElement){ 
    this.loading = true;
    await this.sleep(3000);
    this.loading = false;
    var datawebsiteViewsChart:any={labels: [],series:[]};
    this.dataactual = this.datarandom[periodo][monedaElement];
    this.simbolo = (monedaElement == '1447')? '(MM)':'(k)';
    let smb = this.simbolo;
    let serie: any=[]
    var acumtotal:any=0;
    for (let index = 0; index < this.dataactual.length; index++) {
      acumtotal+=this.dataactual[index].monto;
       this.dataactual[index].acum = acumtotal;
    }

    this.dataactual.forEach(element => {
      datawebsiteViewsChart.labels.push(element.dia);
      this.totalCartera+= element.monto;
      serie.push(this.totalCartera);
    });
    datawebsiteViewsChart.series.push(serie);
     
    

    var optionswebsiteViewsChart = {
        axisX: {
            showGrid: false
        },
        axisY: {             
          labelInterpolationFnc: function(value) {
            return Math.floor(value) + smb;  // Redondea las etiquetas del eje X a enteros
          },
          high: Math.abs(this.totalCartera+10),
        }, 
        height: 400,
        chartPadding: { top: 0, right: 5, bottom: 0, left: 20}
    };
    var responsiveOptions: any[] = [
      
    ];
    var websiteViewsChart = new Chartist.Line('#websiteViewsChart', datawebsiteViewsChart, optionswebsiteViewsChart, responsiveOptions);

    //start animation for the Emails Subscription Chart
    this.startAnimationForBarChart(websiteViewsChart);
  }
  tipoMoneda(event){
    this.monedaElement = event;
    this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);
  }
}
